import React from 'react';
import './CreateFood.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { image_api, var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import cimage from '../../images/burger/b1.png';
import Pagination from 'react-js-pagination';
import { useParams } from 'react-router-dom';
import Loader from '../Loader/Loader';


const VariantFoodMaster = () => {
  const history = useHistory();
  const { id } = useParams(); // Access the ID from the URL
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);
  const [categories, setCategories] = useState([]);
  const [datas, setData] = useState([]);

  const [ loading, setLoading ] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const ItemCodeOptions = [

    { value: 'Burger', label: 'Burger' },
    { value: 'Briyani', label: 'Briyani' },
    { value: 'Breakfast', label: 'Breakfast' },
    // Add more options as needed
  ];

  const ItemCategoryOptions = [

    { value: 'semi burger', label: 'semi burge' },
    { value: 'small burger', label: 'small burger' },
    { value: 'large burger', label: 'large burger' },
    // Add more options as needed
  ];

  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    food_id:id,
    variant_name: '',
    description: '',
    price: '',
    organic_price:'',
    is_active: 1,
    variant_image: null,
  });
const [updateformData, setUpdateFormData] = useState({
  food_id:id,
  variant_name: '',
  description: '',
  price: '',
  organic_price: '',
  is_active: null,
  variant_image: null,
});

console.log(formData)

const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

 const [modalVisible, setModalVisible] = useState(false);
 const [selectedVariant, setSelectedVariant] = useState(null);
 const [subVariants, setSubVariants] = useState([]);

 // Add these with your other state declarations
const [showGroupForm, setShowGroupForm] = useState(false);
const [isEditingGroup, setIsEditingGroup] = useState(false);
const [groupFormData, setGroupFormData] = useState({
  name: "",
  remarks: "",
  image: null,
  price: "",
  organic_price: ""
});


// Add these handler functions
const handleCreateGroupItem = () => {
  setShowGroupForm(true);
  setIsEditingGroup(false);
  setGroupFormData({
    name: "",
    remarks: "",
    image: null,
    price: "",
    organic_price: ""
  });
};

const handleGroupFormSubmit = async () => {
  try {
    const token = localStorage.getItem("Token");
    const formData = new FormData();
    
  const payload = {
  variant_id: selectedVariant.id,
  sub_variant_name: groupFormData.name,
  remarks: groupFormData.remarks,
  price: groupFormData.price,
  organic_price: groupFormData.organic_price
};

    if (isEditingGroup) {
      // Update existing sub-variant
      await axios.put(`${var_api}sub-variant/put/${groupFormData.id}`, payload, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        },
      });
      Swal.fire("Success", "Sub-variant updated successfully!", "success");
    } else {
      // Create new sub-variant
      await axios.post(`${var_api}sub-variant/post`, payload, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json"
        },
      });
      Swal.fire("Success", "Sub-variant created successfully!", "success");
    }

    // Refresh the sub-variants list
    fetchSubVariants(selectedVariant);
    setShowGroupForm(false);
  } catch (error) {
    console.error("Error saving sub-variant", error);
    Swal.fire("Error", "Failed to save sub-variant!", "error");
  }
};

const handleEditSubGroupItem = (subVariant) => {
  setShowGroupForm(true);
  setIsEditingGroup(true);
  setGroupFormData({
    id: subVariant.id,
    name: subVariant.sub_variant_name,
    remarks: subVariant.remarks,
    price: subVariant.price,
    organic_price: subVariant.organic_price,
    image: null
  });
};

const handleDeleteSubGroupItem = async (id) => {
  try {
    const token = localStorage.getItem("Token");
    await axios.delete(`${var_api}sub-variant/delete/${id}`, {
      headers: {
        Authorization: token,
      },
    });
    Swal.fire("Success", "Sub-variant deleted successfully!", "success");
    fetchSubVariants(selectedVariant);
  } catch (error) {
    console.error("Error deleting sub-variant", error);
    Swal.fire("Error", "Failed to delete sub-variant!", "error");
  }
};


// Filtering tables based on search
const filteredTables = datas.filter((item) => {
  return (
    item.variant_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description.toLowerCase().includes(searchTerm.toLowerCase()) 
  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
useEffect(() => {
  // Check if id is valid and fetch data
  if (id) {
    const fetchData = async () => {
      try {
        const token=localStorage.getItem('Token');
        const response = await axios.get(`${var_api}variant-food-master/get/${id}`,{
          headers:{
            Authorization:`${token}`
          }
        });
        setData(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchData();
  }
}, [id]); // Trigger the effect when the id changes
const fetchData = async () => {
  try {
    const token=localStorage.getItem('Token');
    const response = await axios.get(`${var_api}variant-food-master/get/${id}`,{
      headers:{
        Authorization:`${token}`
      }
    });
    setData(response.data);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error fetching data:", error);
    }
  }
};


      const fetchCategories = async () => {
        setLoading(true);
        // const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}category-master/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setCategories(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          setTables([])
        }
      };



      const fetchSubCategory = async () => {
        setLoading(true);
        // const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}sub-category-master/get`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setSubCategory(user);
          
        } catch (error) {
          setLoading(false);
           if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
          setTables([])
        }
      };

      const fetchTables = async () => {
        setLoading(true);
        const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}food-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          setTables([])
        }
      };
      

   

 
      



 // Function to handle checkbox change
 const handleCheckboxChange = (index) => {
  const updatedShops = [...formData.shops];
  const selectedShop = updatedShops[index];
  
  // Toggle is_active property
  updatedShops[index] = {
      ...selectedShop,
      is_active: selectedShop.is_active === 1 ? 0 : 1
  };

  setFormData(prevState => ({
      ...prevState,
      shops: updatedShops
  }));
};


  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
  

  
   const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file);
    if (file) {
      setFormData({
        ...formData,
        variant_image: file,
      });
    }
  };


  const handleImageUpdateChange = (e) => {
    const file = e.target.files[0];
    console.log("file", file);
    if (file) {
      setUpdateFormData({
        ...updateformData,
        variant_image: file,
      });
    }
  };

  const handleCodeSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData({ ...formData, [name]: selectedOption.value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPostLoading(true);

      // Create a new FormData object
  const formDataToSubmit = new FormData();
  formDataToSubmit.append('variant_name', formData.variant_name);
  formDataToSubmit.append('food_id', formData.food_id);
  formDataToSubmit.append('description', formData.description);
  formDataToSubmit.append('price', formData.price);
  formDataToSubmit.append('organic_price', formData.organic_price);
  formDataToSubmit.append('is_active', formData.is_active);
  formDataToSubmit.append('variant_image', formData.variant_image);  // Append image
  
    try {
      const token=localStorage.getItem('Token');
      const response = await axios.post(`${var_api}variant-food-master/post`, formDataToSubmit,{
        headers:{
          Authorization:`${token}`,
          'Content-Type': 'multipart/form-data',
        }
      });
      console.log(response.data); // Handle the response as needed
      setCreate(false); // Close modal after success
      fetchData();
      setFormData({
        food_id:id,
    variant_name: '',
    description: '',
    price: '',
    is_active: 1,
    variant_image: null,
    });
      Swal.fire({
        icon: "success",
        title: "Variant Food Created!",
        text: "Variant Food created successfully!.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `${error.response.data.error}`,
        confirmButtonText: "OK",
      });
    } finally {
      setPostLoading(false);
    }
  };

  const handlePutSubmit = async (e) => {
    e.preventDefault();
    setPostLoading(true);


    // Create FormData to send the form data and the image together
  const formData = new FormData();
  formData.append('variant_name', updateformData.variant_name);
  formData.append('description', updateformData.description);
  formData.append('price', updateformData.price);
  formData.append('organic_price', updateformData.organic_price);
  formData.append('is_active', updateformData.is_active);
  formData.append('food_id', updateformData.food_id);
  formData.append('variant_image', updateformData.variant_image); // Append the selected image

  
    try {
      const token = localStorage.getItem('Token'); // Retrieve token if required
      const response = await axios.put(
        `${var_api}variant-food-master/put/${updateformData.id}`, // Replace with your API endpoint
        formData,
        {
          headers: {
            Authorization: `${token}`, // Include token if needed
            'Content-Type': 'multipart/form-data', 
          },
        }
      );
  
      if (response.status === 200) {
        Swal.fire('Success', 'Variant Food updated successfully!', 'success');
        setIsEdit(false); // Close the modal
        fetchData(); // Refresh the table data
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
      Swal.fire('Error', 'Failed to update food!', 'error');
    } finally {
      setPostLoading(false);
    }
  };

     //delete method for remove UOM
   const handleDeleteEmployeee = (id) => {
    setShow(true);
    setEmployeeD(id);
    }


    //delete the employeee
    const handleDelete = () => {
      const token = localStorage.getItem("Token"); // Adjust the key based on where the token is stored
    
      axios
        .delete(`${var_api}variant-food-master/delete/${EmployeeD}`, {
          headers: {
            Authorization: `${token}`, // Pass the token in the Authorization header
          },
        })
        .then((response) => {
          if (response.status === 200) {
            fetchData();
            setShow(false);
            Swal.fire("Success", "Food Removed Successfully!", "success");
            // Perform any other actions you need on success
          } else if (response.status === 404) {
            console.log("Table not found");
            Swal.fire("Error", "Food not found!", "error");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
          Swal.fire("Error", "Failed to Remove Food!", "error");
          // Handle the error as needed
        });
    };    



    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
      console.log("data",data)
      setUpdateFormData({
          id:data.id,
          food_id:data.food_id,
    variant_name: data.variant_name,
    description: data.description,
    price: data.price,
    organic_price: data.organic_price,
    is_active: data.is_active,
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};


//Oncahnge function for update role
const handleRoleUpdateChange = (selectedOption) => {
  console.log("hjdahj",selectedOption.value)
  setUpdateFormData({ ...updateformData, e_role: selectedOption.value});
};



  //Go to home page
  const handleback = () => {
    history.push('/create-food')
  }

  const handleToggleActive = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1; // Toggle the status
    try {
      const token = localStorage.getItem('Token'); // Retrieve the token if needed
      const response = await axios.put(
        `${var_api}variant-food-master/put/${id}`, // API endpoint
        { is_active: newStatus }, // Update only the `is_active` field
        {
          headers: {
            Authorization: `${token}`, // Include token in headers
          },
        }
      );
  
      if (response.status === 200) {
        Swal.fire('Success', `Status updated to ${newStatus === 1 ? 'Active' : 'Inactive'}!`, 'success');
        fetchData(); // Refresh the table data
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
      Swal.fire('Error', 'Failed to update status!', 'error');
    }
  };

   const fetchSubVariants = async (variant) => {
    setLoading(true);
    setSubVariants([]);
    try {
      const token = localStorage.getItem("Token"); // Get token from storage
      const res = await axios.get(`${var_api}sub-variant/getby-variant/${variant.id}`, {
        headers: {
          Authorization: token,
        },
      });
      setSubVariants(res.data);
      setModalVisible(true);
      setSelectedVariant(variant);
    } catch (error) {
      console.error("Error fetching sub-variants", error);
    } finally {
      setLoading(false);
    }
  };


    return(
      <>         <Layout>

       {loading && <Loader />}

            <div class="splitcsc">
          
      <div style={{border:"none",padding:"15px",width:"105%",minHeight:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}  style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Variant Food</Button>{' '}
      
      <div>
    
     
       <div class="row">
         <div class="col">
         <h4 className='ushefm'> <i className="bi bi-arrow-left-circle-fill" onClick={handleback} /> VARIANT FOOD MASTER</h4>
         </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
      style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
    <br/>
      <div className="table-container" style={{  maxHeight:"540px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Variant Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Regular Price</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Organic Price</th>
       <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Sub Variant</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
  <div className="loader-containeru">
    <div className="spinneru"></div>
  </div>
) : (
  <tbody className="body-half-screen">
    {currentItems.length === 0 ? (
      <tr>
        <td colSpan="10" style={{ textAlign: 'center' }}>No Data Available</td>
      </tr>
    ) : (
      currentItems.map((item, index) => (
        <tr style={{ padding: "7px" }} key={index}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>
            {index + 1}
          </th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
          {item.variant_image ? (
                <img src={`${image_api}/${item.variant_image}`} alt="Variant" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
              ) : (
                <span>No Image</span> // Placeholder text if no image
              )}
            {" "}{item.variant_name}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.description}
          </td>
         
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.price}
          </td>

           <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.organic_price}
          </td>
          <td>
             <span
    className={`badge ${item.sub_variant_count > 0 ? "bg-light text-success" : "bg-light text-secondary"}`}
    style={{
      border: item.sub_variant_count > 0 ? "2px solid green" : "2px dashed gray",
      borderRadius: "999px",
      padding: "5px 10px",
      fontWeight: "500"
    }}
    onClick={() => fetchSubVariants(item)}
  >
    {item.sub_variant_count} Sub Variants
  </span>
          </td>
        
          <td style={{ textAlign: "left" }}>
            <div className="form-check form-switch" style={{ display: "flex", justifyContent: "left" }}>
            <input
      className="form-check-input"
      type="checkbox"
      role="switch"
      checked={item.is_active === 1} // Convert to boolean for the checkbox
      onChange={() => handleToggleActive(item.id, item.is_active)} // Call the handler on toggle
    />
            </div>
          </td>
          <td style={{ textAlign: "left" }}>
            <i
              className="bi bi-pencil-square"
              onClick={()=>handleUpdateEmployee(item)}
              style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}
            ></i>{' '}
            <i
              className="bi bi-trash"
              onClick={() => handleDeleteEmployeee(item.id)}
              style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}
            ></i>
          </td>
        </tr>
      ))
    )}
  </tbody>
)}

</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Variant Food Name 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update variant </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form className="py-2" onSubmit={handlePutSubmit}>
          {/* Other Input Fields */}
          <div className="row">
            <div className="col">
              <label htmlFor="variant_name">Variant Name</label>
              <input
                type="text"
                className="form-control"
                name="variant_name"
                placeholder="Food Name"
                value={updateformData.variant_name}
                onChange={handleInputUpdateChange}
                required
              />
            </div>
            <div className="col">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                className="form-control"
                name="description"
                placeholder="Food Code"
                value={updateformData.description}
                onChange={handleInputUpdateChange}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <label htmlFor="price">Price</label>
              <input
                type="number"
                className="form-control"
                name="price"
                placeholder="Food price"
                value={updateformData.price}
                onChange={handleInputUpdateChange}
                required
                min= "0.1"
                step= "0.1"
              />
            </div>

              <div className="col">
              <label htmlFor="price">Organic Price</label>
              <input
                type="number"
                className="form-control"
                name="organic_price"
                placeholder="Food price"
                value={updateformData.organic_price}
                onChange={handleInputUpdateChange}
                required
                min= "0.1"
                step= "0.1"
              />
            </div>
            <div className="col">
          <label htmlFor="image">Variant Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            accept="image/*"
            onChange={handleImageUpdateChange} // Handle image change
          />
          </div>
          </div>

          <br />
            {postLoading ? (
              <span>Loading...</span>
            ) : (
              <button
                type="submit"
                className="btn btn-success"
                style={{ borderRadius: '10px',    float: 'right',
                  marginRight: '5px', }}
              >
                Update
              </button>
              
            )}
             <button
          className="btn btn-danger"
          onClick={() => setIsEdit(false)}
          style={{
            borderRadius: '10px',
            float: 'right',
            marginRight: '5px',
          }}
        >
          Cancel
        </button>
        </form>
        </Modal.Body>
      </Modal> 

      <Modal
      show={isCreate}
      onHide={() => setCreate(false)}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Food Variant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="py-2" onSubmit={handleSubmit}>
          {/* Other Input Fields */}
          <div className="row">
            <div className="col">
              <label htmlFor="variant_name">Variant Name</label>
              <input
                type="text"
                className="form-control"
                name="variant_name"
                placeholder="Food Name"
                value={formData.variant_name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="col">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                className="form-control"
                name="description"
                placeholder="Food Code"
                value={formData.description}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="col">
              <label htmlFor="price">Regular Price</label>
              <input
                type="number"
                className="form-control"
                name="price"
                placeholder="Food price"
                value={formData.price}
                onChange={handleInputChange}
                required
                min= "0.1"
                step= "0.1"
              />
            </div>

            <div className="col">
              <label htmlFor="price">Organic Price</label>
              <input
                type="number"
                className="form-control"
                name="organic_price"
                placeholder="Food price"
                value={formData.organic_price}
                onChange={handleInputChange}
                required
                min= "0.1"
                step= "0.1"
              />
            </div>
            <div className="col">
          <label htmlFor="variant_image">Variant Image</label>
          <input
            type="file"
            className="form-control"
            name="variant_image"
            onChange={handleImageChange}
          />
        </div>
          </div>

          <br />
            {postLoading ? (
              <span>Loading...</span>
            ) : (
              <button
                type="submit"
                className="btn btn-success"
                style={{ borderRadius: '10px',    float: 'right',
                  marginRight: '5px', }}
              >
                Create
              </button>
              
            )}
             <button
          className="btn btn-danger"
          onClick={() => setCreate(false)}
          style={{
            borderRadius: '10px',
            float: 'right',
            marginRight: '5px',
          }}
        >
          Cancel
        </button>
        </form>
       
      </Modal.Body>
    </Modal>

      <Modal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
         backdrop="static"
      keyboard={false}
      size="lg"
      >
         <Modal.Header closeButton>
        <Modal.Title>Sub Variant for {selectedVariant?.variant_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <div className="d-flex justify-content-between align-items-center mb-3">
              {/* <h5 className="mb-0">Group Items</h5> */}
              <Button variant="primary" size="sm" onClick={handleCreateGroupItem}>
                + Add Sub Variant
              </Button>
            </div>

            {showGroupForm && (
  <form className="border p-3 rounded mb-4 bg-light">
    <div className="row">
      <div className="col-md-3">
        <input
          type="text"
          placeholder="Name"
          className="form-control"
          value={groupFormData.name}
          onChange={(e) =>
            setGroupFormData({ ...groupFormData, name: e.target.value })
          }
        />
      </div>
      <div className="col-md-3">
        <input
          type="text"
          placeholder="Remarks"
          className="form-control"
          value={groupFormData.remarks}
          onChange={(e) =>
            setGroupFormData({ ...groupFormData, remarks: e.target.value })
          }
        />
      </div>
      <div className="col-md-3">
        <input
          type="number"
          placeholder="Price"
          className="form-control"
          value={groupFormData.price}
          onChange={(e) =>
            setGroupFormData({ ...groupFormData, price: e.target.value })
          }
          min="0.1"
          step="0.1"
        />
      </div>
      <div className="col-md-3">
        <input
          type="number"
          placeholder="Organic Price"
          className="form-control"
          value={groupFormData.organic_price}
          onChange={(e) =>
            setGroupFormData({ ...groupFormData, organic_price: e.target.value })
          }
          min="0.1"
          step="0.1"
        />
      </div>
      {/* <div className="col-md-2">
        <input
          type="file"
          className="form-control"
          onChange={(e) =>
            setGroupFormData({ ...groupFormData, image: e.target.files[0] })
          }
        />
      </div> */}
    </div>
    <div className="mt-3 text-end">
      <Button
        variant="success"
        size="sm"
        onClick={handleGroupFormSubmit}
        className="me-2"
      >
        {isEditingGroup ? "Update" : "Create"}
      </Button>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => {
          setShowGroupForm(false);
          setIsEditingGroup(false);
          setGroupFormData({ 
            name: "", 
            remarks: "", 
            image: null,
            price: "",
            organic_price: ""
          });
        }}
      >
        Cancel
      </Button>
    </div>
  </form>
)}
                
         {subVariants.length === 0 ? (
            <p>No Sub Group Items Available</p>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Remarks</th>
                  <th>Regular Price</th>
                  <th>Organic Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subVariants.map((group, index) => (
                  <tr key={group.id || index}>
                    <td>{index + 1}</td>
                    <td>
                     {group.sub_variant_name}
                    </td>
                    <td>{group.remarks}</td>
                    <td>{group.price}</td>
                    <td>{group.organic_price}</td>
                    <td>
  <i
    className="bi bi-pencil-square text-success"
    style={{ cursor: "pointer", marginRight: "10px" }}
    onClick={() => handleEditSubGroupItem(group)}
  ></i>
  <i
    className="bi bi-trash text-danger"
    style={{ cursor: "pointer" }}
    onClick={() => handleDeleteSubGroupItem(group.id)}
  ></i>
</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          </Modal.Body>
      </Modal>


            {/* </div> */}
       </Layout></>

        
    )
}

export default VariantFoodMaster;